import React from 'react';
import './Features.css';
import { FaCalendarAlt, FaClipboardList, FaInfoCircle, FaUserCheck, FaCommentDots } from 'react-icons/fa';

const Features = () => {
  return (
    <section className="features" id="features">
      <div className="features-container">
        <div className="features-content">
          <div className="features-text">
            <h2 className="features-title">
              Never lose a new patient to voicemail again
            </h2>
            <p className="features-subtitle">
              Our AI receptionist handles all your patient interactions professionally and efficiently
            </p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-content-row">
                <div className="feature-icon">
                  <FaCalendarAlt />
                </div>
                <h3 className="feature-title">Schedule Patients 24/7</h3>
              </div>
              <p className="feature-description">
                Book appointments anytime, even outside office hours. Never miss a potential patient again.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-content-row">
                <div className="feature-icon">
                  <FaClipboardList />
                </div>
                <h3 className="feature-title">Keep Records</h3>
              </div>
              <p className="feature-description">
                Automatically maintain detailed patient records and appointment history in your system.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-content-row">
                <div className="feature-icon">
                  <FaInfoCircle />
                </div>
                <h3 className="feature-title">Treatment Information</h3>
              </div>
              <p className="feature-description">
                Provide patients with accurate treatment details, pricing, and procedure information instantly.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-content-row">
                <div className="feature-icon">
                  <FaUserCheck />
                </div>
                <h3 className="feature-title">Follow Up</h3>
              </div>
              <p className="feature-description">
                Automated follow-up calls and messages to ensure patient satisfaction and care continuity.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-content-row">
                <div className="feature-icon">
                  <FaCommentDots />
                </div>
                <h3 className="feature-title">Feedback</h3>
              </div>
              <p className="feature-description">
                Collect patient feedback and reviews to help improve your practice and build reputation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
